// extracted by css-extract-rspack-plugin
export default {"branchName":"BranchLink-module__branchName__YxodJ"};